// extracted by mini-css-extract-plugin
module.exports = {"optional":"form-indicator_optional__6lE5N token-typography-body-100 mds-typography-font-weight-regular"};